import { v4 as uuidv4 } from 'uuid';

export const CORRELATION_HEADER = 'X-Correlation-Id';

export function newCorrelationId(): string {
  return uuidv4();
}
